import React, { useContext, useEffect, useState } from "react";
import {
    Label,
    Wrapper,
    SingleValueWrapper,
    OptionWrapper,
} from "./styled.js";
import SelectAsync from 'react-select/lib/Async';
import { fetchUsers } from "./service";
import { AppContext } from "hocs/withAppContext";

const normalizeDisplayName = (user) =>
    [user.firstName, user.lastName]
        .filter(n => !!n)
        .join(' ')
        .trim() || user.username;

const SingleValue = ({ innerProps, innerRef, data }) =>
    <SingleValueWrapper ref={innerRef} {...innerProps}>
        {normalizeDisplayName(data)}
    </SingleValueWrapper>;

const Option = ({ innerProps, innerRef, data }) =>
    <OptionWrapper ref={innerRef} {...innerProps}>
        <p>{normalizeDisplayName(data)}</p>
    </OptionWrapper>
;

export const SelectUser = ({ label, placeholder, required,
                               value = '', onChange, error }) => {
    const { role } = useContext(AppContext);
    const roleId = role.objectId;

    const [defaultOptions, setDefaultOptions] = useState([]);
    useEffect(() => {
        fetchUsers(roleId).then(setDefaultOptions);
    }, [roleId]);

    return <Wrapper className="select-box">
        {label && <Label required={required}>{label}</Label>}
        <SelectAsync
            className={ error ? 'data-error': ''}
            classNamePrefix="react-select"
            placeholder={placeholder}
            required={required}
            defaultOptions={defaultOptions}
            loadOptions={q => fetchUsers(roleId, q)}
            components={{ SingleValue, Option }}
            isClearable={true}
            value={value}
            onChange={onChange}
        />
    </Wrapper>
};

export default SelectUser;
